// produzioniSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    produzioni: [],
    singleProduzione: {},
    singleProduzioneId:{},
    isLoading: false,
    error: null,
};

const produzioniSlice = createSlice({
    name: "produzioniData",
    initialState,
    reducers: {
        setProduzioni: (state, action) => {
            state.produzioni = action.payload;
        },
        addProduzione: (state, action) => {
            state.produzioni.push(action.payload);
        },
        addProduzioneId: (state, action) => {
            state.singleProduzione = action.payload;
        },
        setSingleProduzioneId: (state, action) => {
            state.singleProduzioneId = action.payload;
            state.singleProduzione = {};
        },
        resetSingleProduzione: (state) => {
            state.singleProduzione = null;
            state.singleProduzioneId = null;
          },
        updateProduzione: (state, action) => {
            const index = state.produzioni.findIndex(
                (item) => item.id === action.payload.id
            );
            if (index !== -1) {
                state.produzioni[index] = action.payload;
            }
        },
        deleteProduzione: (state, action) => {
            state.produzioni = state.produzioni.filter(
                (item) => item.id !== action.payload
            );
        },
        apiRequestStart: (state) => {
            state.isLoading = true;
            state.error = null;
        },
        apiRequestSuccess: (state) => {
            state.isLoading = false;
        },
        apiRequestFailure: (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        },
    },
});

export const {
    setProduzioni,
    addProduzione,
    addProduzioneId,
    updateProduzione,
    deleteProduzione,
    apiRequestStart,
    apiRequestSuccess,
    apiRequestFailure,
    setSingleProduzioneId,
    resetSingleProduzione
} = produzioniSlice.actions;

// Selectors
export const selectProduzioni = (state) => state.produzioni?.produzioni;
export const selectSingleProduzione = (state) => state.produzioni?.singleProduzione;
export const selectIsLoading = (state) => state.produzioni?.isLoading;
export const selectError = (state) => state.produzioni?.error;

export default produzioniSlice.reducer;
